import type { LauncherFeed } from '../front-door/launcher/feed'
import { useProgramme, type Programme } from './live'

// Nateva's launcher feed (src/front-door/launcher/feed.ts): the Programme
// facts from Nateva's database (live.ts), shaped for the front page. Nothing
// new is said here; every line comes from the programme_* tables.

const SHORT: Record<string, string> = { azure: 'Azure', github: 'GitHub' }

export function shapeLauncherFeed(p: Programme): LauncherFeed {
  const ask = (k: string) => p.asks.find((a) => a.key === k)
  return {
    asOf: p.asOf ?? '',
    programmePath: '/home',
    projects: p.projects.map((pr) => ({
      slug: pr.slug,
      app: pr.app,
      name: pr.name,
      lead: pr.lead,
      leadEmail: pr.leadEmail,
      what: pr.what,
      keywords: [pr.replaces, pr.app].filter((k): k is string => !!k),
      stage: pr.stage,
      step: p.stages.indexOf(pr.stage),
      stages: p.stages,
      next: pr.next,
      waitingOn: pr.waitingOn.filter((k) => ask(k)?.status === 'waiting').map((k) => SHORT[k] ?? ask(k)?.title ?? k),
      path: `/home?project=${pr.slug}`,
    })),
    updates: p.projects
      .flatMap((pr) => pr.updates.map((u) => ({ on: u.on, text: u.text, project: pr.name, path: `/home?project=${pr.slug}` })))
      .sort((a, b) => b.on.localeCompare(a.on)),
    pages: [
      ...(p.plan.length ? [{ title: 'The plan', line: p.plan.map((s) => s.title).join(', '), path: '/home?view=plan' }] : []),
      ...p.reports.map((r) => ({ title: r.title, line: `${r.kind} report, ${r.pages} ${r.pages === 1 ? 'page' : 'pages'}. ${r.line}`, path: `/home?report=${r.id}` })),
      { title: 'Using Claude', line: 'What to ask Claude, and how to start.', path: '/learn' },
    ],
  }
}

/** The front page's feed. Null while it loads, and when the programme cannot be read (the page then shows the apps alone). */
export function useLauncherFeed(): { feed: LauncherFeed | null; loading: boolean } {
  const q = useProgramme()
  return { feed: q.data ? shapeLauncherFeed(q.data) : null, loading: q.isPending }
}
